module.exports = __webpack_public_path__ + "media/images/metronic/datatables/back_enabled_hover-d769ab4a367dd82f69b2f86af630c037.png";